import { Component } from '@angular/core';

@Component({
  selector: 'ds-rg-signup',
  templateUrl: './rg-signup.component.html',
  styleUrl: './rg-signup.component.scss'
})
export class RgSignupComponent {
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();
}
